import { Button, PageContent, PageHeader } from '@/components';
import { useProject } from '@/features/project/_hooks/project';
import { ProjectsPageDynamicLink } from '@/features/project/projects/_components/ProjectsPageDynamicLink';
import { useChangeBrowserTabTitleEffect, useId } from '@/hooks';
import { isPS } from '@/utils';
import { type FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import { FundOwnerForLocalGovernmentReportPage } from './FundOwnerForLocalGovernmentReportPage';

const PAGE_SIZE = 'A4';

export const ProjectFundOwnerForLocalGovernmentElement: FC = () => {
  const { t } = useTranslation();
  const contentRef = useRef<HTMLDivElement>(null);

  const { id } = useId();
  const project = useProject(id);
  const handlePrint = useReactToPrint({
    pageStyle: `@page { size: ${PAGE_SIZE} landscape; margin: 10mm 1mm; }`,
    contentRef,
  });

  useChangeBrowserTabTitleEffect({
    title:
      project.data &&
      t('report-fund-owner-for-local-government-individual-table-title', {
        year: project.data.fiscalYear,
        projectName: project.data.name,
      }),
    hideFallback: true,
  });

  return (
    <>
      <PageHeader
        title={t('pdf-preview-page')}
        breadcrumbs={[
          { title: <ProjectsPageDynamicLink /> },
          {
            title: t('project-details-page'),
            href: isPS()
              ? `${location.pathname.replace('/public-site', '').split('/').slice(0, -1).join('/')}`
              : `${location.pathname.split('/').slice(0, -1).join('/')}`,
          },
          {
            title: t('pdf-preview-page'),
          },
        ]}
        buttons={
          <Button type="primary" onClick={handlePrint}>
            {t('export-ledger')}
          </Button>
        }
      />
      <PageContent>
        {project.data?.sheetType === 'KS' &&
          project.data.fundAdditionalAttributes?.fundSheetType ===
            'local-government' && (
            <div ref={contentRef}>
              <FundOwnerForLocalGovernmentReportPage
                projectId={project.data.id}
                fiscalYear={project.data.fiscalYear}
                projectName={project.data.name}
                pageSize={PAGE_SIZE}
              />
            </div>
          )}
      </PageContent>
    </>
  );
};
